export const getEvents = (state) => state.calendar.events;
export const getDatesInView = (state) => state.calendar.datesInView;
export const getEventError = (state) => state.calendar.error || '';
